module.exports = __webpack_public_path__ + "img/yve.3e7962a4.png";